import React from 'react';
import { MenuButton as ReakitMenuButton } from 'reakit';

interface MenuButtonProps {
    children: React.ReactNode;
    disabled?: boolean;
}

/**
 * Augments the children passed to act as a menu button.
 * Children should accept event listeners and aria-properties for accessibility.
 * Follows the WAI-ARIA Menu Button pattern.
 */
export const MenuButton = React.forwardRef<HTMLButtonElement, MenuButtonProps>(function (
    { children, ...rest },
    ref
) {
    return (
        <ReakitMenuButton ref={ref} {...rest}>
            {(disclosureProps) => {
                if (React.isValidElement(children)) {
                    return React.cloneElement(children, disclosureProps);
                }

                return;
            }}
        </ReakitMenuButton>
    );
});
